export const policyType = {
    PUBLIC: 'ציבורית',
    PRIVATE: 'פרטית',
    SHABAN: 'שב"ן',
    GROUP: 'קבוצתית',
    GLOBAL: 'כללית'
}

export const fileType = {
    naot: 'גילוי נאות',
    policy: 'פוליסה',
    embedded: 'קובץ מושתל',
    doc: 'תיק ביטוחי',
    commission: 'עמלה'
}
